export type ConsentState = 'granted' | 'denied';

declare global {
  interface Window {
    dataLayer: any[];
    gtag?: (...args: any[]) => void;
  }
}

export const loadGtag = (gtmId: string): void => {
  if (typeof window === 'undefined') return;
  if (window.gtag) return; // already loaded

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  } as any;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gtmId}`;
  document.head.appendChild(script);
};

export const gtag = (...args: any[]) => {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag.apply(window, args);
};

export const setDefaultConsent = (defaults?: Partial<Record<string, ConsentState>>) => {
  const base = {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    personalization_storage: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'denied',
    security_storage: 'denied'
  } as Record<string, ConsentState>;
  const payload = { ...base, ...defaults };
  gtag('consent', 'default', payload);
};

export const updateConsent = (options: Partial<Record<string, ConsentState>>) => {
  gtag('consent', 'update', options);
};


